export default 'https://help.onevision.kazaar.com/';
